module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<label class="b-input b-input-phone ' +
((__t = ( this.disabled ? 'b-input-phone-disabled' : '' )) == null ? '' : __t) +
'">\r\n  <div class="r-control"></div>\r\n</label>\r\n';

}
return __p
}